// extracted by mini-css-extract-plugin
export default {"products":"vt-z","card":"wt-z","oosMessaging":"xt-z"};